import { REFER_A_FRIEND_OFFER_ID } from '@ahmdigital/constants';

import { nextReduxWrapper } from '../../../src/client/store/create-store';
import Page from '../../../src/client/pages/offers/refer-a-friend';

export const getServerSideProps = nextReduxWrapper.getServerSideProps(() => async ({ req }) => ({
  props: {
    actions: {},
    location: {
      hash: '',
      pathname: req.url,
      query: {},
      search: '',
    },
    match: {
      params: {
        offerId: REFER_A_FRIEND_OFFER_ID.REFER,
        productIds: [],
      },
    },
  },
}));

export default Page;
